import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

// ─────────────────────────────────────────────
// main.tsx — Vite entry point
// StrictMode enabled — double-renders in dev
// to catch side effects. No impact on production.
// ─────────────────────────────────────────────

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)